export const setSearchedFilm = (searchedFilm) => ({
  type: "SET_SEARCHED_FILM",
  payload: searchedFilm,
});
